export enum State {
  Active = 0,
  EndOfLife = 1,
  Deprecated = 2,
  RevokedByPublisher = 3,
  OrderingIsTemporaryDisabled = 4,
  AssetUnlisted = 5
}
